import dynamic from 'next/dynamic';

const AddTeamModal = dynamic(() => import('./AddTeamModal'));

const TeamsGrid = dynamic(() => import('./TeamsGrid/TeamsGrid'));

const EditTeamModal = dynamic(() => import('./EditTeamModal/EditTeamModal'));

const EditTeamForm = dynamic(() => import('./EditTeamForm/EditTeamForm'));

const TeamMembers = dynamic(() => import('./TeamMembers/TeamMembers'));

const DeactivateTeamModal = dynamic(() =>
  import('./DeactivateTeamModal/DeactivateTeamModal')
);
const TeamSidebar = dynamic(() => import('./TeamSidebar/TeamSidebar'));

export {
  TeamsGrid,
  AddTeamModal,
  EditTeamModal,
  EditTeamForm,
  TeamMembers,
  DeactivateTeamModal,
  TeamSidebar,
};
